import { atom } from 'recoil';

import type { User, Vendor } from 'lib/graphql';

const themeState = atom<'light' | 'dark'>({ key: 'theme', default: 'dark' });

const userState = atom<User>({ key: 'user', default: undefined });

const vendorState = atom<Vendor>({ key: 'vendor', default: undefined });

export { themeState, userState, vendorState };
